import { Link } from "react-router-dom";

interface DoctorRecommendationLinkProps {
  to?: string;
  label?: string;
  target?: string;
}

const DoctorRecommendationLink = ({
  to = "https://www.docnote.com/contact-us",
  label = "Recommend your doctor",
  target = "_blank",
}: DoctorRecommendationLinkProps) => (
  <Link to={to} target={target} className="text-docnote-orange">
    {label}
  </Link>
);

export default DoctorRecommendationLink;
